<p>typebedroom-extends works!</p>
